var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frise-bas",attrs:{"onerror":"this.style.display='none'"}},[_c('img',{attrs:{"src":_vm.urlImg,"decoding":"async","alt":"frise"}})])}
var staticRenderFns = []

export { render, staticRenderFns }